const initialState = {
    responseFooterList: {},
    responseFooter: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "FOOTER_LIST_RESPONSE":
            newState.responseFooterList = action.value
            break;
        case "FOOTER_RESPONSE":
            newState.responseFooter = action.value
            break;
        case "UPLOAD_IMAGE_BACKOFFICE_RESPONSE":
            newState.responseUploadImage = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;